/**
 * Platform-aware shortcut labels shared by the keymap overlay, tooltips and
 * hints — single source for the Mac/PC modifier glyph.
 */

export const isMac = typeof navigator !== 'undefined' && /Mac|iP(hone|ad|od)/.test(navigator.platform);

export const mod = isMac ? '⌘' : 'Ctrl';

export const shiftMod = isMac ? '⇧ ⌘' : 'Ctrl Shift';

export function withShortcut(label: string, keys: string): string {
    return `${label} (${keys})`;
}
